import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Назад',
      changePassword: 'Изменить пароль',
      copiedVaultId: 'Скопировано!',
      copyVaultID: 'Скопировать ID Vault',
      create: 'Создать',
      next: 'Далее',
      notSure: 'Не могу сказать точно',
      signUp: 'Зарегистрироваться',
      submit: 'Подать',
      updatePassword: 'Обновить пароль',
    },
    Errors: {
      createReportFailed: 'Не удалось создать обращение.',
    },
    ReportStatus: {
      CLOSED: 'Закрыто',
      INVESTIGATING: 'Расследование',
      NEW: 'Подано',
      READ: 'Прочитано',
    },
    general: {
      navbar: {
        caseSettings: 'Настройки дела',
        changePassword: 'Сменить пароль',
        logOut: 'Выйти',
        notifications: 'Уведомления',
        notificationsDrawer: {
          appFileScanFailed: 'Файл не прошел проверку безопасности',
          appReportMatch: 'Ваша запись GoTogether была сопоставлена',
          appReportReassigned:
            'Новый менеджер по работе с клиентами был назначен',
          case: 'Дело',
          caseAssigned: 'Вы назначены на дело',
          caseImporterJobCompleted: {
            PartialSuccess: 'Импорт вашего дела завершился с ошибками',
            failure: 'Импорт вашего дела не удался',
            success: 'Импорт вашего дела успешно завершен',
          },
          caseLinked: 'Связанный случай',
          caseTeamInvite: 'Добавлено к делу',
          caseUnlinked: 'Случай отсоединен',
          dataSanitisation: 'Детали отчета обновлены',
          emptyDescription: 'Проверьте позже для новых уведомлений',
          emptyTitle: 'Вы все обновили',
          importId: 'Идентификатор импорта:',
          learnMore: 'Узнать больше',
          markAllAsRead: 'Отметить все как прочитанное',
          newMessage: 'Новое сообщение',
          newReport: 'Получен новый отчет',
          permissionRemoved: 'Удален из дела',
          postSSubmissionFile: 'Добавлены файлы доказательств',
          report: 'Отчет',
          reportAssigned: 'Отчет назначен вам',
          reportStatusChange: 'Статус отчета изменен',
          reporterAnonymised: 'Ваши данные были анонимизированы',
          reporterReportSubmitted: {
            subtitle: 'Мы рекомендуем сохранить копию вашего отчета',
            title: 'Отчет представлен',
          },
          mitigationPlanReminder: 'Требуется утверждение плана снижения рисков',
          staleCase: 'Нерешенный случай',
        },
        privacyStatement: 'Заявление о конфиденциальности',
        reporter: {
          myReports: 'Мои отчеты',
        },
        settings: 'Настройки',
        technicalSupport: 'Техническая поддержка',
        title: 'Аккаунт',
      },
      time: {
        day: 'День',
        days: 'Дни',
        hour: 'Час',
        hours: 'Часы',
        minute: 'Минута',
        minutes: 'Минуты',
        second: 'Второй',
        seconds: 'Секунды',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Анонимный',
        autoTranslate: 'Автоматический перевод отключен по умолчанию.',
        backToMessages: 'Назад к сообщениям',
        caseSettings: 'Настройки дела.',
        changeInProfile:
          'Если вы хотите изменить эту настройку, вы можете сделать это в своем профиле',
        deletedByMessage: 'Удалено {{author}}',
        deletedMessageLabel: 'Это сообщение было удалено',
        description:
          'Когда включен автоматический перевод, все сообщения отчетов будут\n          автоматически переведены с помощью AI на основе языка по умолчанию,\n          выбранного в вашем браузере.',
        descriptionSecondHalf:
          'Оригинальная версия всех сообщений всегда сохраняется и может быть найдена в чате.',
        messagePlaceholder: 'Начните печатать...',
        messageSettings: 'Настройки сообщений.',
        originalMessages: 'Оригинал',
        showMoreBanner: 'Узнайте больше о автоматических переводах',
        titlev2: 'Читайте все сообщения на предпочитаемом вами языке.',
        translatedMessageLabel: 'Переведенное сообщение',
        translatedMessages: 'Переведено',
        understood: 'Понял',
      },
      Country: {
        description: 'В какой стране вы работаете?',
        header: 'В какой стране вы работаете?',
        noOptions: 'Страны не найдены',
        other: 'Другое',
        placeholder: 'Поиск страны...',
      },
      CreatePublicReport: {
        createReport: 'Создать новое обращение',
        helpPage: 'Перейдите на нашу страницу помощи',
        loginToOpr: 'Войдите для отслеживания отчетов',
        or: 'или',
        passwordPlaceholder: 'Введите пароль',
        phoneNumberLoginFailed:
          'Вход не удался, номер телефона / пин-код неверны',
        phoneNumberPlaceholder: 'Введите свой номер телефона',
        phoneNumberTooltip:
          'Введите номер телефона, который вы использовали для связи с VaultTalk',
        pinPlaceholder: 'Введите ПИН',
        reportIntroductionParagraph1:
          'При сообщении об инциденте вам зададут несколько вопросов для помощи в документировании вашего опыта.',
        reportIntroductionParagraph2:
          'Прежде чем отправить, у вас есть возможность остаться анонимным, чтобы защитить вашу конфиденциальность.',
        reportIntroductionParagraph3:
          'После отправки заявления вы можете войти в систему в любое время, чтобы увидеть ход рассмотрения вашего дела и общаться с менеджером по работе с клиентами.',
        reportIssue: 'Сообщить о проблеме',
        usernameLoginFailed:
          'Вход не удался, неправильное имя пользователя/пароль',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Требуется указать отношение к компании',
            reportedCategoryRequired: 'Требуется указать категорию',
          },
        },
        vaultId: 'ID Vault',
        vaultIdPlaceholder:
          'Введите свой адрес электронной почты или идентификатор Vault',
        vaultIdTooltip:
          'Для анонимных отчетов идентификатор Vault является буквенно-цифровым. Если отчет не был анонимным, идентификатор Vault - это ваш адрес электронной почты.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Ваш пароль',
        yourPhoneNumber: 'Ваш номер телефона',
        yourPin: 'Ваш 6-значный пин-код',
        yourVaultId: 'Ваш идентификатор Vault',
      },
      CustomHeader: {
        companyLogo: 'Логотип компании',
        openReporting: 'Открыть обращение',
        userSettings: 'Пользовательские настройки',
      },
      Date: {
        approximateDescription:
          'Вы помните примерную дату, когда произошло это событие?',
        approximatePlaceholder:
          'Пример: 6 месяцев назад / в прошлом году / в прошлом ноябре',
        cancel: 'отмена',
        clear: 'очистить',
        description: 'Вы помните дату, когда произошло это событие?',
        header: 'В какой день недели это произошло?',
        ok: 'ОК',
        placeholder: 'Пример: 21 июня 2020 г.',
      },
      Description: {
        whatHappened: 'Что произошло?',
        whatHappenedPlaceholder: 'Опишите произошедшее своими словами...',
        whatHappenedText: 'Опишите произошедшее своими словами.',
      },
      Details: {
        disclaimer:
          'Эти детали будут раскрыты в вашем отчете. Если вы хотите остаться анонимным, убедитесь, что они не содержат идентифицирующей информации.',
        emailPlaceholder: 'Адрес электронной почты (необязательно)',
        fullNamePlaceholder: 'ФИО (необязательно)',
        header: 'Ваши данные',
        nonAnonSubtitle:
          'Пожалуйста, укажите ваше имя или адрес электронной почты. Если вы хотите получать уведомления об этом отчете, добавьте соответствующий адрес электронной почты ниже.',
        nonOptionalEmailPlaceholder: 'Электронная почта',
        nonOptionalFullNamePlaceholder: 'Полное имя',
        subtitle:
          'Если вы хотите получать уведомления об этом отчете, добавьте подходящий адрес электронной почты ниже.',
      },
      Emotion: {
        description: 'Что вы при этом чувствовали? Как это на вас повлияло?',
        header: 'Как это на вас повлияло?',
        placeholder: 'Начните печатать...',
      },
      Evidence: {
        addedHeading: 'Добавлено',
        deletedMessage: 'был удален',
        deletedStatus: 'Удалено',
        failedToOpenFileMessage:
          'Не удалось открыть файл. Пожалуйста, попробуйте еще раз.',
        fileStatuses: {
          infectedUpload: 'Отмечено системой безопасности',
          passedUpload: 'Прошел проверку безопасности',
          pendingUpload: 'Проверка безопасности в процессе',
          readyForDownload: 'Готово для скачивания',
        },
        mobileErrorMessage: 'Отмеченные файлы: сообщите вашему кейс-менеджеру',
        nameHeading: 'Имя',
        statusHeading: 'Статус',
        tableTitle: 'Доказательство',
        webErrorMessage:
          'Отмеченные файлы: Если ваш(и) файл(ы) был(и) помечен(ы), пожалуйста, отправьте сообщение менеджеру по делу.',
      },
      FileUpload: {
        addFiles: 'Добавить файлы',
        addMoreFiles: 'Добавьте больше файлов',
        confirm: 'Подтвердить',
        description:
          'Добавление файлов в качестве доказательств может помочь улучшить эффективность решения вашего дела менеджером. Пожалуйста, учитывайте содержание файла (включая метаданные файла), если вы хотите остаться анонимными, и уважайте права других людей и соответствующие законы.',
        dragDrop: 'Перетащите файлы сюда или',
        errorMessage:
          'Файл(ы) не удалось загрузить из-за сетевой ошибки. Нажмите ниже, чтобы отправить сообщение вашему менеджеру по работе с клиентами для получения помощи.',
        fileLimit: 'Ограничение размера каждого файла: 100МБ',
        fileUploadLimitText: 'Вы можете загрузить только 10 файлов',
        header: 'Добавить доказательства',
        helpArticle: 'статья помощи',
        highlighted: 'просмотр файлов',
        information: 'Поддерживаемые типы файлов',
        moreInformation:
          'Для получения дополнительной информации, пожалуйста, смотрите это <a>статья помощи</a>',
        postSubmissionErrorMessage:
          "Мы не смогли загрузить ваши файлы из-за системной ошибки. Пожалуйста, снова выберите 'подтвердить'.",
        tooltipAudio: 'Аудио:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Документы:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Изображения:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Текст:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Видео:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Файл слишком большой',
          invalidFileType: 'Неподдерживаемый тип файла: {{extension}}',
          systemError: 'Системная ошибка',
          tooManyFiles: 'Максимальное количество файлов - {{maxFiles}}',
        },
        uploadFiles: 'Загрузить файлы',
      },
      Loading: {
        loading:
          'Пожалуйста, подождите, пока мы отправляем ваш отчет кейс-менеджеру...',
        postSubmissionLoading:
          'Пожалуйста, подождите, пока мы отправляем ваш(и) файл(ы)...',
      },
      Location: {
        description: 'Где это произошло?',
        header: 'Где это произошло?',
        placeholder: 'Пример: в офисе',
      },
      MessageListBox: {
        messageCaseManager: 'Написать специалисту по ведению случаев',
        report: 'Обращение {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Перевод отключен',
        enableTranslationLabelEnabled: 'Перевод включен',
        enableTranslationsDescription:
          'Включите автоматический перевод и читайте все сообщения отчетов на предпочитаемом вами языке. Переведенный язык основан на языке, выбранном на вашем устройстве.',
        enableTranslationsHeader:
          'Включить автоматический перевод для сообщений отчета',
        enableTranslationsSubDescriptionv2:
          'Вы можете переключаться между переведенным и оригинальным языком в каждом чате.',
        updateTranslationFailed: 'Обновление перевода не удалось',
        updateTranslationSuccess: 'Настройки перевода успешно обновлены',
      },
      Password: {
        changePasswordHeader: 'Изменить пароль',
        createNewPassword: 'Создайте новый пароль',
        createPasswordHeader: 'Ваш пароль',
        currentPasswordPlaceholder: 'Введите текущий пароль',
        description:
          'Пароль должен содержать не менее 9 символов, одну заглавную букву и одну цифру',
        enterCurrentPassword: 'Введите ваш текущий пароль',
        forgottenPasswordInstructions:
          'Введите свой буквенно-цифровой идентификатор Vault (не ваш электронный адрес) и адрес электронной почты для сброса пароля.',
        newDescription:
          'Создайте надежный пароль для обеспечения безопасности вашего аккаунта. Начните печатать, чтобы увидеть руководство ниже.',
        passwordPlaceholder: 'Создайте пароль',
        passwordResetRequestedDescription:
          'Если ваш идентификатор Vault существует в нашей системе, вы получите электронное письмо с инструкциями по сбросу пароля.',
        passwordResetRequestedHeader: 'Запрошена ссылка для сброса пароля',
        reenterPlaceholder: 'Введите пароль еще раз',
        subtitle:
          'Создайте пароль, чтобы подать это обращение и просматривать его в будущем',
        yourVaultId: 'Ваш идентификатор Vault',
        yourVaultIdPlaceholder:
          'Введите ваш Vault ID (например, {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Вы хотите рассказать о поведении конкретного человека или нескольких человек? Вы знаете их имена? Вы можете их описать?',
        header: 'Участвующие люди',
        placeholder:
          'Начните печатать. Используйте запятую, чтобы добавить несколько имен или описаний',
      },
      PoweredByVault: 'На базе{{company}}',
      PrivacyStatement: 'Заявление о конфиденциальности продукта',
      PublicMessageList: {
        myMessages: 'Мои сообщения',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader:
          'Добавлены доказательства к существующему отчету',
        backToReportId: 'Вернуться к отчету ID: {{reportId}}',
        description:
          'Добавление файлов в качестве доказательств может помочь повысить эффективность решения вашего дела менеджером. Пожалуйста, учитывайте содержимое файла (включая метаданные файла), если вы хотите остаться анонимным, и уважайте права других людей и соответствующие законы. Для получения дополнительной информации, пожалуйста, смотрите это. <a>статья помощи</a>',
        header: 'Добавьте дополнительные доказательства в отчет',
        vaultTalkOpenCaseHeader: 'Добавьте доказательства в ваш отчет',
      },
      PublicReport: {
        anonymous: 'Анонимно',
        backToReports: 'Назад к обращениям',
        skipped: 'Пропущено',
      },
      PublicReportCard: {
        addEvidence: 'Добавить дополнительные доказательства',
        messageCaseManager: 'Написать специалисту по ведению случаев',
        reportId: 'Идентификатор обращения:',
        submitted: 'Подано',
        vaultTalkClosedCaseCTA: 'Просмотреть доказательства',
        vaultTalkOpenCaseCTA: 'Добавить доказательства',
        viewAdditionalEvidence: 'Посмотреть дополнительные доказательства',
        viewReport: 'Смотреть обращение',
      },
      PublicReportsList: {
        reportingSystem: 'Система подачи обращений',
      },
      Question: {
        placeholder: 'Начните печатать...',
        question: 'Предоставить детали',
        questionText:
          'Пожалуйста, поделитесь с нами своей проблемой, обновлением или вопросом.',
      },
      Relationship: {
        header: 'Ваше отношение к организации',
        tellUsAbout: 'Расскажите нам о своих отношениях с организацией.',
      },
      ResponsiveNavMenu: {
        messages: 'Мои сообщения',
        reports: 'Мои отчеты',
      },
      Site: {
        description: 'На каком объекте вы работаете?',
        header: 'На каком объекте вы работаете?',
        noOptions: 'Объекты не найдены',
        other: 'Другое',
        placeholder: 'Поиск объекта...',
      },
      SpamPuzzle: {
        dialog: 'Решите эту задачу, чтобы продолжить',
      },
      SubmissionTypes: {
        reportIssue: 'Выберите категорию',
        whatType: 'Выберите категорию, которая лучше всего описывает ваш отчет',
      },
      SubmitSuccess: {
        category: '<bold>Категория:</bold> {{category}}',
        country: '<bold>Страна:</bold> {{country}}',
        dateSubmitted: '<bold>Дата подачи:</bold> {{date}}',
        recordYourVaultID: 'Запомните эту информацию для входа',
        successInformation: 'Больше информации',
        successMessage:
          'Ваш отчет был отправлен и готов к рассмотрению. Все прикрепленные файлы, которые требуют внимания, будут помечены после входа. Войдите в систему, чтобы просмотреть обновления отчета и отправить сообщение вашему менеджеру по работе с клиентами.',
        successSanitationMessage:
          'Сохраните копию для своих записей и храните ваш Vault-ID в безопасности — вам потребуется он для доступа к обновлениям и отправки сообщений вашему менеджеру по делу.',
        successSanitationTagline:
          'Ваш отчет был отправлен и безопасно сохранен.',
        successThankYou: 'Спасибо за ваш отчет!',
        viewReport: 'Просмотреть отчет',
      },
      Time: {
        approximateDescription:
          'Вы помните примерное время, когда произошло это событие?',
        approximatePlaceholder: 'Пример: утром, во второй половине дня',
        description: 'Вы помните время, когда произошло это событие?',
        header: 'В какое время это произошло?',
        invalidTime: 'Время нужно указать в формате ЧЧ:ММ',
      },
      UserSettingsDialog: {
        changePassword: 'Изменить пароль',
        closeDialog: 'Закрыть диалог',
        logout: 'Выйти из системы',
        messageSettings: 'Настройки сообщений',
        userSettings: 'Пользовательские настройки',
      },
      Witnesses: {
        description: 'Кто-то еще знает или видел, что произошло?',
        header: 'Есть ли свидетели?',
        placeholder: 'Начните печатать...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Отправить сообщение',
        title: 'Сообщение Менеджеру по делам',
        translationHeader: 'Узнайте больше об автоматических переводах',
      },
      ReportCard: {
        addEvidence: 'Добавить доказательства',
        submissionModeVia: 'через {{submissionMode}}',
        viewEvidence: 'Просмотреть доказательства',
      },
      ReportList: {
        yourReports: 'Ваши отчеты',
      },
      ReportingActivate: {
        buttonText: 'Продолжить',
        description:
          'Если ваша организация зарегистрировала вас на аккаунт, мы отправим вам письмо с инструкциями по завершению настройки.',
        emailInput: 'Электронная почта',
        header: 'Введите свой рабочий адрес электронной почты',
        successAccount:
          'Если ваша организация зарегистрировала вас для учетной записи, мы отправим вам электронное письмо с инструкциями по завершению настройки.',
        successEmail:
          'Если вы сразу не видите это, пожалуйста, подождите несколько минут и обновите свой почтовый ящик.',
        successHeading: 'Спасибо',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Добавьте доказательства в ваш отчет',
        descriptionText:
          'Добавление файлов в качестве доказательств может помочь повысить эффективность работы вашего менеджера по решению споров. Пожалуйста, учитывайте содержимое файла (включая метаданные файла), если вы хотите остаться анонимным, и уважайте права других людей и соответствующие законы. Для получения дополнительной информации, пожалуйста, ознакомьтесь с этой <a>статьей помощи</a>.',
        emptyMessage: 'Никаких дополнительных доказательств не загружено',
      },
      ReportingChangePassword: {
        back: 'Назад',
        description:
          'Создайте надежный пароль для обеспечения безопасности вашего аккаунта. Начните вводить текст, чтобы увидеть рекомендации ниже.',
        errorToast: 'Не удается создать пароль, недействительный токен.',
        header: 'Сменить пароль',
        incorrectCurrentPassword:
          'Текущий пароль неверен. Пожалуйста, проверьте его и попробуйте снова.',
        invalidToken: 'Недействительный токен',
        passwordUpdated: 'Пароль обновлен',
        passwordUpdatedDescription:
          'Ваш пароль был успешно обновлен. Спасибо, что предприняли этот шаг, чтобы обеспечить безопасность ваших данных!',
        passwordUsedBefore: 'Повторное использование пароля не разрешено',
        passwordUsedBeforeDescription:
          'Для вашей безопасности вы не можете повторно использовать шесть своих последних паролей. Пожалуйста, выберите новый, уникальный пароль, чтобы сохранить безопасность вашего аккаунта и попробуйте снова.',
        toastDescription:
          'Ваш пароль был успешно обновлен. Спасибо, что приняли этот шаг для обеспечения безопасности ваших данных!',
        toastMessage: 'Пароль обновлен',
        updatePasswordCTA: 'Обновить пароль',
      },
      ReportingConnect: {
        cancelButton: 'Отмена',
        connectButton: 'Подключить',
        disclaimer:
          'Подключение вашего аккаунта Slack к вашему аккаунту Vault обеспечивает безопасное и частное соединение.<br /><br />Подключившись, вы можете сообщить о неправильном поведении или задать вопрос прямо в Slack. У вас всегда будет возможность сообщать анонимно после подключения. Ваша приватность и безопасность - наши главные приоритеты.',
        heading:
          'Vault Platform запрашивает разрешение на доступ к вашей учетной записи Slack {{organisationName}}',
        listHeading: 'Что сможет делать Vault?',
        permissionIdentity: {
          extraInfo:
            'Vault будет иметь возможность просматривать идентификацию вашего пользователя в Slack.',
          heading: 'Просмотр информации о личности пользователя',
        },
        permissionNotifications: {
          extraInfo:
            'Vault сможет отправлять вам уведомления на ваш аккаунт Slack, касающиеся любых обновлений поданного отчета или вопроса',
          heading: 'Отправить вам уведомления',
        },
        permissionOverview: {
          extraInfo:
            'Vault отобразит обзор всех отправленных материалов на главной странице',
          heading: 'Обзор заявок',
        },
        permissionSubmitReport: {
          extraInfo:
            'Это даст Vault разрешение отправлять отчет или задавать вопрос напрямую вашей организации из Slack.',
          heading: 'Отправить отчет или вопрос от вашего имени',
        },
        successfulConnectionDescription:
          'Ваш Vault аккаунт и Slack аккаунт теперь связаны. Вы можете закрыть эту вкладку и вернуться в Slack.',
        successfulConnectionHeading: 'Успешно подключено',
        unsuccessfulConnectionDescription:
          'Что-то пошло не так. Пожалуйста, закройте эту вкладку и вернитесь в Slack, чтобы попробовать снова.',
        unsuccessfulConnectionHeading: 'Соединение не удалось',
      },
      ReportingForgotPassword: {
        description:
          'Введите адрес электронной почты, связанный с вашим аккаунтом, и мы отправим вам ссылку для сброса вашего пароля.',
        heading: 'Забытый пароль',
        invalidTokenError: 'Не удалось создать пароль, недействительный токен.',
        passwordReuseError: 'Повторное использование пароля не разрешено',
        passwordReuseErrorDescription:
          'Для вашей безопасности вы не можете повторно использовать шесть своих последних паролей. Пожалуйста, выберите новый, уникальный пароль, чтобы сохранить вашу учетную запись в безопасности и попробуйте снова.',
        sendLink: 'Отправить ссылку для сброса',
        sendLinkFailure: 'Что-то пошло не так',
        sendLinkFailureDescription:
          'Вернитесь в <a>Центр репортёров</a> и попробуйте снова. Если проблема продолжается, свяжитесь с нами по адресу <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Ссылка для сброса пароля отправлена',
        sendLinkSuccessDescription:
          'Мы отправили ссылку для сброса пароля на {{email}}',
        updatePasswordSuccess: 'Пароль обновлен',
        updatePasswordSuccessDescription:
          'Ваш пароль был успешно обновлен. Спасибо, что приняли это решение для обеспечения безопасности ваших данных!',
      },
      ReportingLogin: {
        accountFrozen: 'Аккаунт заморожен',
        accountLocked:
          'Вход в систему был совершен слишком много раз неправильно. Аккаунт заблокирован на срок до 1 часа. Сброс пароля невозможен в течение этого времени.',
        accountLockedPermanently:
          'Ваш аккаунт был заблокирован. Используйте функцию сброса пароля, чтобы восстановить доступ, или свяжитесь с системным администратором для дальнейшей помощи.',
        createAccountCTA: 'Зарегистрироваться на аккаунт',
        currentPassword: 'Текущий пароль',
        emailLabel: 'Ваш Email',
        forgotPassword: 'Забыли свой пароль?',
        loginButton: 'Вход',
        newPasswordPlaceholder: 'Новый пароль',
        passwordFailMessage:
          'Вернитесь в приложение Vault в Slack и попробуйте снова. Если проблема продолжается, свяжитесь с нами по адресу techsupport@vaultplatform.com',
        passwordFailTitle: 'Что-то пошло не так',
        passwordLabel: 'Ваш Rassword',
        passwordPlaceholder: 'Введите свой пароль',
        passwordResetRequired: 'Требуется сброс пароля',
        passwordSuccessfullySetMessage:
          'Вернитесь в приложение Vault в Slack и аутентифицируйтесь с вашим новым паролем, чтобы продолжить с того места, на котором вы остановились.',
        passwordSuccessfullySetTitle: 'Пароль успешно установлен',
        reenterPlaceholder: 'Введите пароль еще раз',
        title: 'Репортерский Хаб',
        tooltip:
          'Если вы еще не устанавливали пароль для приложения Vault, следуйте сюда, чтобы начать. Если вы забыли свой пароль, воспользуйтесь ссылкой "Забыли пароль" ниже.',
        usernameLoginFailed:
          'Вход не выполнен, имя пользователя или пароль неверны',
      },
      ReportingReset: {
        failureDescription:
          'Вернитесь в приложение Vault в Slack и попробуйте снова. Если проблема продолжает сохраняться, свяжитесь с нами по адресу <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Что-то пошло не так',
        successDescription:
          'Вернитесь в приложение Vault в Slack и аутентифицируйтесь с вашим новым паролем, чтобы продолжить с того места, где вы остановились.',
        successHeading: 'Пароль успешно установлен',
      },
      noReports: {
        description:
          'Все отправленные отчеты будут отображаться здесь. Узнайте больше о способах, которыми вы можете отправить отчет.',
        descriptionHelpArticle: 'эта статья помощи',
        errorDescription:
          'У нас возникли трудности с загрузкой ваших отчетов. Пожалуйста, попробуйте обновить страницу.',
        errorDescriptionSecondary:
          'Если это не работает, пожалуйста, свяжитесь с нами по адресу',
        errorTitle: '⚠️ Ой, что-то пошло не так',
        title: 'У вас пока нет отчетов',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Включите автоматический перевод и читайте все сообщения отчетов на предпочитаемом вами языке. Переведенный язык основывается на языке, выбранном на вашем устройстве.',
          autoTranslationDescription2:
            'Вы можете переключаться между переведенным и оригинальным языком в каждом чате.',
          autoTranslationTitle:
            'Включить автоматический перевод сообщений отчета',
          header: 'Настройки сообщений',
          subHeader: 'Настройте отображение сообщений',
        },
        notificationSettings: {
          emailDescription:
            'Получайте уведомления по электронной почте о важных обновлениях ваших отчетов',
          emailTitle: 'Уведомления по электронной почте',
          header: 'Настройки уведомлений',
          subHeader: 'Настройте, как вы получаете уведомления',
        },
        title: 'Настройки',
        updatedSettingsFailure: 'Не удалось обновить ваши настройки',
        updatedSettingsSuccess: 'Ваши настройки успешно обновлены',
      },
    },
    validators: {
      passwordLength: 'Пароль должен содержать более 9 символов',
      passwordLowercase: 'Пароль должен содержать хотя бы 1 строчную букву',
      passwordMissMatch:
        'Содержимое полей «Пароль» и «Подтвердите пароль» должно совпадать.',
      passwordNumeric: 'Пароль должен содержать хотя бы 1 цифру',
      passwordUppercase: 'Пароль должен содержать хотя бы 1 заглавную букву',
    },
    validatorsNew: {
      passwordLength: 'Между 10 и 30 символами',
      passwordLowercase: 'По крайней мере одна строчная буква',
      passwordMissMatch: 'Пароли не совпадают',
      passwordNumeric: 'По крайней мере один номер',
      passwordSpecialCharacter: 'По крайней мере один специальный символ',
      passwordUppercase: 'По крайней мере одна заглавная буква',
    },
  },
};

export default translations;
